import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Path } from '../_components/Path';
import { examService } from '../_services/exam.service';
import { Overview } from './Overview';
import { isEnglish } from '../_helpers';
import { QnA } from './QnA';

export const Exam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { topic, mode, attempt } = location.state;

  const [query, setQuery] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    getQuestionAnswerWithPrevNext({
      topic_id: topic?._id,
    });
  }, [topic]);

  // to get question with answer and prev and next _id data
  function getQuestionAnswerWithPrevNext(queryTemp) {
    setIsLoading(true);
    let queryNew = queryTemp ? queryTemp : query;
    queryNew.mode = mode;
    setQuery(queryNew);
    if (queryNew.mode == 1) {
      queryNew.attempt = attempt ? attempt : 1;
    }
    examService.getQuestionAnswerWithPrevNext(queryNew).then(
      (res) => {
        if (res.data) {
          setIsLoading(false);
          setQuestions(res.data);
        } else {
          setIsLoading(false);
          setQuestions({});
        }
      },
      (err) => {
        console.log('errrorrrrrrr from getQuestionAnswerWithPrevNext', err);
        setIsLoading(false);
      },
    );
  }

  const handleNext = (nextId, order, currentId) => {
    if (questions.answer && questions.index + 1 == questions.length) {
      navigate('/examresult', { state: { topicData: topic, mode, attempt } });
    } else {
      getQuestionAnswerWithPrevNext({
        question_id: nextId,
        topic_id: topic?._id,
        isNext: true,
        currentOrder: order,
        currentQuesId: currentId,
      });
    }
  };

  const handlePrev = (prevId, order, currentId) => {
    getQuestionAnswerWithPrevNext({
      question_id: prevId,
      topic_id: topic?._id,
      isPrev: true,
      currentOrder: order,
      currentQuesId: currentId,
    });
  };
  return (
    <div className='exam'>
      <div className='container'>
        <Path
          pathList={[
            { name: 'Course List', link: 'courselist' },
            {
              name: 'Subject',
              link: `course/${topic?.course_id}`,
              id: topic?.course_id,
            },
            { name: 'Topics' },
            { name: 'Test' },
          ]}
        />
        <div className='qna-header'>
          {topic?.topic_name && (
            <div
              className={'topicname mb-3 ' + (isEnglish(topic?.topic_name) ? 'ltrtext' : 'rtltext')}
            >
              {topic?.topic_name}
            </div>
          )}
          {topic?._id && (
            <div
              className={
                'd-flex gap-2 ' +
                (isEnglish(topic?.topic_name) ? 'justify-content-start' : 'justify-content-end')
              }
            >
              <div className='descitem'>
                <img src='/img/question_icon.png' className='desc_icon' /> {topic?.totalQuestions}{' '}
                Questions
              </div>
              <div className={'examlabel ' + (mode == 1 ? 'testlbl' : '')}>
                {mode == 1 ? 'Test' : 'Practice'}
              </div>
            </div>
          )}
        </div>
        <div className='d-flex flex-wrap'>
          <QnA
            handleNext={handleNext}
            handlePrev={handlePrev}
            item={questions}
            QnLength={questions?.length}
            mode={mode}
            attempt={attempt}
            setQuestions={setQuestions}
            isLoading={isLoading}
          />
          <Overview QnLength={questions?.length} item={questions} />
        </div>
      </div>
    </div>
  );
};
